import type { LucideIcon } from "@/components/icons"

import { LaunchTile } from "@/components/layouts/launch-tile"

type CreateMediaButtonProps = {
  icon: LucideIcon
  title: string
  description: string
  onClick: () => void
}

/** Studio AI "create" tile — thin wrapper over the shared {@link LaunchTile}. */
export function CreateMediaButton({ icon, title, description, onClick }: CreateMediaButtonProps) {
  return (
    <LaunchTile
      className="w-full"
      description={description}
      icon={icon}
      orientation="vertical"
      title={title}
      onClick={onClick}
    />
  )
}
